import React, { Component } from "react";
import {
  Form,
  FormField,
  TextBox,
  PasswordBox,
  ComboBox,
  Panel,
  LinkButton,
  Messager,
} from "rc-easyui";
import { isEmpty } from "../../../helpers";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from "../../../constants";
import { Button } from "reactstrap";

const axios = require("axios");

class AddUser extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.state = {
      isLoading: false,
    };
  }

  handleChange(name, value) {
    this.props.handleChange(name, value);
  }

  handleUpdate() {
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    var form = this.props.userFields;
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };
    if (form["password"] === undefined) {
      form["password"] = "";
    } else {
      if (form.password !== form.confirm_password) {
        alert("Password and Confirm Password should be same");
        return;
      }
      const regx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}$)/;
      //console.log(regx.test(form.password));
      if (!regx.test(form.password)) {
        alert(
          "Password field must have atleast 1 Speical , 1 Small , 1 capital , 1 Numeric Character and Minimum 8 charcter length"
        );
        return;
      }
    }
    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (access_token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          //console.log(form);
          axios
            .put(API_URL + "api/user/" + form.id, form, axiosConfig)
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // User  Updated Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleUpdate();
          }
        }
      } else {
        //console.log("Front End Form Validaion ");
      }
    });
  }

  handleSubmit() {
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    var form = this.props.userFields;
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };

    if (form.password !== form.confirm_password) {
      alert("Password and Confirm Password should be same");
      return;
    }

    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (access_token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .post(API_URL + "api/user", form, axiosConfig)
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // User  Saved Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }

                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              //console.log(error);
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleSave();
          }
        }
      } else {
        //console.log("Front End Form Validaion ");
      }
    });
  }

  render() {
    const user = this.props.userFields;
    const rules = this.props.validationRules;
    const operation = this.props.operation;
    const loading = this.state.isLoading;

    return (
      <div>
        <Panel title='User Registration' bodyStyle={{ padding: 20 }}>
          <Messager
            ref={(ref) => (this.messager = ref)}
            showHeader={false}
            borderType='none'
            content={({ title, msg, buttons, reload }) => (
              <div className='alert-content'>
                <h3>{title}</h3>
                <div
                  style={{ marginBottom: 5 }}
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
                <div className='m-buttons'>
                  {buttons.map((button, index) => (
                    <LinkButton
                      key={index}
                      text={button.text}
                      onClick={() => {
                        this.messager.close(button);
                        if (reload) {
                          window.location.reload();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          />
          <div
            className='loadingmodel'
            style={{ display: loading ? "block" : "none" }}
          ></div>
          <Form
            ref={this.props.innerRef}
            model={user}
            labelWidth={400}
            labelAlign='left'
            rules={rules}
            // validateRules={this.customValidations()}
            labelPosition='top'
            onChange={this.handleChange.bind(this)}
          >
            <FormField name='fullname' label='Full Name:'>
              <TextBox
                value={user.fullname}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField name='contactno' label='Contact:'>
              <TextBox
                value={user.contactno}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField name='username' label='Username:'>
              <TextBox
                value={user.username}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField name='password' label='Password:'>
              <PasswordBox
                style={{ width: "100%" }}
                value={user.password}
              ></PasswordBox>
            </FormField>

            <FormField name='confirm_password' label='Confirm Password:'>
              <PasswordBox
                style={{ width: "100%" }}
                value={user.confirm_password}
              ></PasswordBox>
            </FormField>

            <FormField name='roleId' label='User Group:'>
              <ComboBox
                style={{ width: "100%" }}
                valueField='id'
                textField='name'
                value={user.roleId}
                data={this.props.allGroups}
              ></ComboBox>
            </FormField>
            <FormField name='enabled' label='Status:'>
              <ComboBox
                data={[
                  { value: true, text: "Active" },
                  { value: false, text: "Inactive" },
                ]}
                editable={false}
                value={user.enabled}
                style={{ width: "100%" }}
              ></ComboBox>
            </FormField>
          </Form>
          <hr />
          <div className='text-center'>
            <Button
              color='primary'
              onClick={
                operation === "Add" ? this.handleSubmit : this.handleUpdate
              }
              disabled={loading ? true : false}
              style={{ marginRight: 20 }}
            >
              {operation === "Add" ? "Save" : "Update"}
            </Button>
            <Button color='danger' onClick={this.props.formClear}>
              Cancel
            </Button>
          </div>
        </Panel>
      </div>
    );
  }
}
export default React.forwardRef((props, ref) => (
  <AddUser innerRef={ref} {...props} />
));
